export default __webpack_public_path__ + "static/media/NanumSquareL.ace03365.ttf";